import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './CardsEmpty.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { AddCardButton } from '@/components/Profile/Cards/AddCardButton';

export const CardsEmpty = () => {
  const { t } = useTranslation();

  return (
    <S.Box>
      <IconBox
        $filename="cards.png"
        $width={145}
        $height={145}
        $iconWidth={145}
        $iconHeight={145}
      />
      <S.Title $variant="1">{t('pages.cabinet.cards_page_empty_text')}</S.Title>

      <AddCardButton />
    </S.Box>
  );
};
